import styled from 'styled-components';
import UserPlaceHolderIcon from '^/assets/icons/project-sidebar/user-placeholder.svg';
import React, { useState, useEffect } from 'react';
import theme from '^/theme';

const colors = theme.colors;

const DEFAULT_COLORS = [
  colors.pointGreen[500],
  colors.neutralGray[400],
  colors.neutralBlue[300],
  colors.lightBlue[300],
  colors.tag.orange.toString(),
  colors.tag.purple.toString(),
];

const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * DEFAULT_COLORS.length);
  return DEFAULT_COLORS[randomIndex];
};

interface AvatarProps {
  src?: string;
  size?: number;
  backgroundColor?: string;
}

const StyledAvatarFallback = styled.div<{ size: number }>(({ size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: `${size}px`,
  height: `${size}px`,
}));

const StyledAvatar = styled.div<{ size: number; backgroundColor: string }>(
  ({ size, backgroundColor }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor,
    color: 'white',
    fontSize: `${size * 1.2}px`,
    fontWeight: 300,
    overflow: 'hidden',
  })
);

const StyledAvatarImage = styled.img<{ size: number }>(({ size }) => ({
  width: `${size}px`,
  height: `${size}px`,
  objectFit: 'cover',
  objectPosition: 'center',
}));

const Avatar: React.FC<AvatarProps> = ({
  src,
  size = 40,
  backgroundColor: propBackgroundColor,
}) => {
  const [errorLoading, setErrorLoading] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState(propBackgroundColor || getRandomColor());

  useEffect(() => {
    if (propBackgroundColor) {
      setBackgroundColor(propBackgroundColor);
    }
  }, [propBackgroundColor]);

  const getFallback = () => (
    <StyledAvatarFallback size={size}>
      <UserPlaceHolderIcon />
    </StyledAvatarFallback>
  );

  return (
    <StyledAvatar size={size} backgroundColor={backgroundColor}>
      {src && !errorLoading ? (
        <StyledAvatarImage
          onError={() => setErrorLoading(true)}
          src={src}
          alt="Avatar"
          size={size}
        />
      ) : (
        getFallback()
      )}
    </StyledAvatar>
  );
};

export default Avatar;
